'use strict';

/**
 * @generated SignedSource<<67674c7f276a691d3d06ade910baaf7f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "journeyStepId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "variation"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "journeyStepId",
                    "variableName": "journeyStepId"
                },
                {
                    "kind": "Variable",
                    "name": "variation",
                    "variableName": "variation"
                }
            ],
            "concreteType": "ContentJourneyDetails",
            "kind": "LinkedField",
            "name": "contentJourneyDetails",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useAuthorableContentsFromRelayQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useAuthorableContentsFromRelayQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "15ac2070b18fa7802c341a9b30dff453",
            "id": null,
            "metadata": {},
            "name": "useAuthorableContentsFromRelayQuery",
            "operationKind": "query",
            "text": "query useAuthorableContentsFromRelayQuery(\n  $journeyStepId: String!\n  $variation: String\n) {\n  contentJourneyDetails(journeyStepId: $journeyStepId, variation: $variation) {\n    key\n    value\n    url\n  }\n}\n"
        }
    };
})();
node.hash = "eb3c1ca7c8e318223f1f54c99a64c0bc";

module.exports = node;
